﻿import moment from "moment";
import slug from "slugify";

export function formatPrice(price: number, perKg: boolean = false, perL: boolean = false) {
    if (price) {
        const numerals = (price % 1 === 0) ? price.toFixed(0) : price.toFixed(2);

        if (perKg) {
            return `R ${numerals} / kg`;
        }

        if (perL) {
            return `R ${numerals} / l`;
        }

        return `R ${numerals}`;
    }
    else {
        return '';
    }
}

export function dateAsAge(source: Date | string) {
    if (source) {
        const since = moment.duration(moment(source).diff(moment()));

        return since.humanize(true);
    }
    else {
        return 'never';
    }
}

export function formatPercentage(source: number, decimals = 1) {
    return `${source.toFixed(decimals)} %`;
}

export function formatWeight(source: number) {
    if (!source) {
        return '';
    }

    if (source < 1) {
        return `${(source * 1000).toFixed(0)} g`;
    }

    if (source % 1 === 0) {
        return `${source.toFixed(0)} kg`;
    }

    return `${source.toFixed(2)} kg`;
}

export function formatVolume(source: number) {
    if (!source) {
        return '';
    }

    if (source < 1) {
        return `${(source * 1000).toFixed(0)} ml`;
    }

    if (source % 1 === 0) {
        return `${source.toFixed(0)} l`;
    }

    return `${source.toFixed(2)} l`;
}

export function formatCurrency(val: number) {
    return val % 1 === 0 ? val.toFixed(0) : val.toFixed(2);
}

export function slugify(val: string, options?: { replacement?: string; remove?: RegExp; lower?: boolean; strict?: boolean; locale?: string; }) {
    options = options ?? {};
    options.strict = options.strict ?? true;
    options.remove = options.remove ?? /[*+~.()'"!:@]/g;

    return slug(val, options);
}